import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { SupplierImportDrawer } from '../modals/supplier-import-drawer/supplier-import-drawer';
import { useOnImportFinished } from '../../../../components/csv-import/data/hooks/use-on-import-finished';
import { ImportStatus } from '../../../../components/csv-import/data/types/import-status';
import { ImportType } from '../../../../components/csv-import/data/types/import-type';
import { useCsvImport } from '../../../../components/csv-import/ui/hooks/use-csv-import';
import Global from '../../../../store/global-selectors';
import { Workflows } from '../../../../tracking/tracking-constants';
import { WorkflowSteps, useTrackWorkflow } from '../../../../tracking/use-workflow-tracking';

type SupplierImportProps = {
  renderOpener: (open: () => void) => React.ReactNode;
  onImportFinish?: () => void;
};

export const SupplierImport = ({ renderOpener, onImportFinish }: SupplierImportProps) => {
  const latestImport = useSelector((state) => Global.selectCsvImportType(state, ImportType.supplier));

  const { open: openModal, close: closeModal, isOpen: isModalOpen } = useCsvImport(ImportType.supplier);

  const trackImportProcess = useTrackWorkflow(Workflows.CSV_SUPPLIER_IMPORT_FLOW);

  const openImportModal = () => {
    if (latestImport.status !== ImportStatus.ACTIVE) {
      trackImportProcess(WorkflowSteps.START, {
        version: 2,
      });
    }
    openModal();
  };

  useOnImportFinished(
    ImportType.supplier,
    useCallback(() => {
      if (isModalOpen && onImportFinish) {
        onImportFinish();
      }
    }, [isModalOpen, onImportFinish]),
  );

  return (
    <>
      {renderOpener(openImportModal)}
      {isModalOpen ? <SupplierImportDrawer onClose={closeModal} trackProcess={trackImportProcess} /> : null}
    </>
  );
};
